






































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import IssueCommentReactionService from '@/services/issue-comment-reaction.service';
import { IssueCommentReactionCountEntity } from '@/entities/issue-comment-reaction-count.entity';
import IssueReactionService from '@/services/issue-reaction.service';
import { IssueReactionCountEntity } from '@/entities/issue-reaction-count.entity';
import { ReactionEntity } from '@/entities/reaction.entity';

@Component<ReactionItem>({
  watch: {
    async show(value) {
      if (value) {
        if (
          'commentId' in this.reaction &&
          this.service instanceof IssueCommentReactionService
        ) {
          this.reactionDetails = await this.service.getMany(
            this.reaction.commentId,
            this.reaction.emoticonId,
          );
        } else if (
          'issueId' in this.reaction &&
          this.service instanceof IssueReactionService
        ) {
          this.reactionDetails = await this.service.getMany(
            this.reaction.issueId,
            this.reaction.emoticonId,
          );
        }
      }
    },
  },
})
export default class ReactionItem extends Vue {
  show = false;

  @Prop()
  service: IssueCommentReactionService | IssueReactionService;

  @Prop({ type: Object })
  reaction: IssueCommentReactionCountEntity | IssueReactionCountEntity;

  reactionDetails: ReactionEntity[] = [];
}
